// @flow
import React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';

import {usePrefs} from 'docs/data';
import type {TerminalCountry} from 'docs/data/integration-builder';
import {Setting} from './Setting';

const messages = defineMessages({
  country: {
    id: 'docsApp.integrationBuilder.settings.country',
    description: 'Country label',
    defaultMessage: 'Country:',
  },
});

type CountrySettingProps = {|
  countries: Array<TerminalCountry>,
|};

export const CountrySetting = ({countries}: CountrySettingProps) => {
  const {getPref, setPref} = usePrefs();
  const countryPref = getPref('country');
  const country =
    countryPref && countries.includes(countryPref) ? countryPref : countries[0];
  if (!countries.includes(countryPref)) {
    setPref('country', countries[0]);
  }

  return (
    <Setting
      label={<FormattedMessage {...messages.country} />}
      pref="country"
      activeItem={country}
      items={countries}
    />
  );
};
